import { render, staticRenderFns } from "./SubscribePinsGraphForFlex.vue?vue&type=template&id=2244810f&scoped=true"
import script from "./SubscribePinsGraphForFlex.vue?vue&type=script&lang=js"
export * from "./SubscribePinsGraphForFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244810f",
  null
  
)

export default component.exports